var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grant-user-button",on:{"click":_vm.grantUser}},[_c('a',{staticClass:"grant-user-text"},[_vm._v(" "+_vm._s(_vm.isBroadcaster ? _vm.$t('community.grantUserForBroadcast.revokeBroadcaster') : _vm.$t('community.grantUserForBroadcast.addBroadcaster'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }